<template>
  <div class="home-box bgff">
    <banner-swiper />
    <div class="def-w">
      <div class="f-b mb-18">
        <div class="left-block">
          <quick-entry class="mt-30" />
        </div>
        <div class="right-block">
          <login-entry class="mt-30" />
        </div>
      </div>
      <carousel-news class="mb-40" />
      <advert-comp adv-type="ad_ht_banner" />
      <recommend-key adv-type="AD_IMPORTANT" class="mb-40" />
      <advert-comp adv-type="AD_A" />
    </div>
    <div class="def-w">
      <asset-transaction
        title="国有资产交易"
        type="1"
        subtitle="/ 公开  公平  公正  规范"
      />
      <advert-comp adv-type="AD_B" class="mt-40" />
      <purchase-block
        title="阳光招标采购"
        subtitle="/ 高效便捷  要素集中  创新业态  阳光公开"
        icon="purchase"
      />
      <!-- <material-procurement
        title="建材采购"
        subtitle=""
        icon="purchase"
      /> -->
      <advert-comp adv-type="AD_C" class="mt-40" />
      <!-- <invitation-procurement  title="阳光招标采购" subtitle="/ 高效便捷  要素集中  创新业态  阳光公开"/> -->
      <asset-transaction
        title="自然资源交易"
        type="2"
        subtitle="/ 创新  协调  绿色  开放  共享"
      />
      <advert-comp adv-type="AD_D" class="mt-40" />
      <bidding-room />
      <!-- <noticechange-block title="结果公告" noticeType="CJGG"/>
      <noticechange-block title="变更公告" noticeType="BGGG"/> -->
      <business-group />
      <friendly-link-top />
    </div>
    <div class="bgf8">
      <friendly-link />
    </div>
  </div>
</template>

<script>
import BannerSwiper from "@/views/home/components/BannerSwiper.vue";
import LoginEntry from "@/views/home/components/LoginEntry.vue";
import QuickEntry from "@/views/home/components/QuickEntry.vue";
import CarouselNews from "@/views/home/components/CarouselNews.vue";
import TabNews from "@/views/home/components/TabNews.vue";
import FAQ from "@/views/home/components/FAQ.vue";
import AdvertComp from "@/views/home/components/AdvertComp.vue";
import PurchaseBlock from "@/views/home/components/PurchaseBlock.vue";
import NoticechangeBlock from "@/views/home/components/NoticechangeBlock.vue";
import AssetTransaction from "@/views/home/components/AssetTransaction.vue";
import FriendlyLinkTop from "@/views/home/components/FriendlyLinkTop.vue";
import FriendlyLink from "@/views/home/components/FriendlyLink.vue";
import BusinessGroup from "@/views/home/components/BusinessGroup.vue";
import BiddingRoom from "@/views/home/components/BiddingRoom.vue";
import {
  INFO_TYPE_OPTIONS,
  SELECT_OPTION_CONFIG,
  UNIT_TYPE
} from "@/utils/constant";
import RecentOpenBidding from "@/views/home/components/RecentOpenBidding.vue";
import ImageCurouselAd from "@/views/home/components/ImageCurouselAd.vue";
import NoticeExhibition from "@/views/home/components/NoticeExhibition.vue";
import RecommendKey from "@/views/home/components/RecommendKey.vue";
import InvitationProcurement from "@/views/home/components/InvitationProcurement.vue";
import MaterialProcurement from "@/views/home/components/MaterialProcurement.vue";

export default {
  name: "Home",
  components: {
    NoticeExhibition,
    RecentOpenBidding,
    BiddingRoom,
    FriendlyLinkTop,
    FriendlyLink,
    BusinessGroup,
    PurchaseBlock,
    NoticechangeBlock,
    AdvertComp,
    FAQ,
    TabNews,
    QuickEntry,
    LoginEntry,
    BannerSwiper,
    ImageCurouselAd,
    CarouselNews,
    AssetTransaction,
    RecommendKey,
    InvitationProcurement,
    MaterialProcurement
  },
  props: {},
  data() {
    return {};
  },
  // 监听属性 类似于data概念
  computed: {
    INFO_TYPE_OPTIONS() {
      return INFO_TYPE_OPTIONS;
    },
    codeParam() {
      return SELECT_OPTION_CONFIG.CODE;
    },
    UNIT_TYPE() {
      return UNIT_TYPE;
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {}
};
</script>

<style scoped lang="scss">
.home-box {
  //padding-bottom: 50px;
  .left-block {
    width: 742px;
  }
  .right-block {
    width: 440px;
  }
}
.bgf8 {
  background: #f8f8f8;
}
</style>
